import {Component, Input, OnInit} from '@angular/core';
import { ClaimDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/claim-dto';
import {debounceTime, distinctUntilChanged, Subject, switchMap} from "rxjs";
import {UpdateInternalNotesService} from "./services/update-internal-notes.service";

@Component({
  selector: 'app-internal-comments',
  templateUrl: './internal-comments.component.html',
  styleUrls: ['./internal-comments.component.scss']
})
export class InternalCommentsComponent implements OnInit {
  @Input() claimDto: ClaimDto | null = null;
  private internalNotes$ = new Subject<string |  null>();

  constructor(private updateInternalCommentsService: UpdateInternalNotesService) {
  }

  ngOnInit(): void {
    this.internalNotes$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((internalNotes  ) =>
        this.updateInternalCommentsService.updateInternalNotes(this.claimDto!.claimId, internalNotes)
      )
    ).subscribe();
  }

  updateInternalNotes() {
    this.internalNotes$.next(this.claimDto!.internalNotes!);
  }
  
}
